// REACT
import { useEffect } from "react";

// MATERIAL UI
import { styled } from "@mui/material";

// FEATURE COMPONENTS
import { TargetOrdersComponentV2 } from "./components/TargetOrdersComponentV2";

// AMPLITUDE
import { trackEvent } from "src/Amplitude";

const TradeWrapper = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "start",
}));

export const Targets = () => {
  useEffect(() => {
    trackEvent("Visit_Page", { page: "Target_Orders" });
  }, []);

  return (
    <TradeWrapper>
      <TargetOrdersComponentV2 />
    </TradeWrapper>
  );
};
